import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-post-network-projects',
  templateUrl: './post-network-projects.component.html',
  styleUrls: ['./post-network-projects.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PostNetworkProjectsComponent {
  @Input() public data: any[] = [];
}
